import { ProfileStatus } from '@trustoo/enums/ProfileStatus'
import { DISABLED_PROFILE_STATUSES } from '@trustoo/utils/profile/isProfileDisabled'

export const S3_PUBLIC = () =>
    (window && window._appConfig && window._appConfig.S3_PUBLIC) ||
    'https://s3-eu-west-1.amazonaws.com/static-test.trustoo.nl/'

export const S3_PRIVATE = () =>
    (window && window._appConfig && window._appConfig.S3_PRIVATE) || 'https://private.trustoo.nl/'

export const STATUS_MAP = {
    1: 'Bouwvergunning verleend',
    2: 'Niet gerealiseerd pand',
    3: 'Bouw gestart',
    4: 'Pand in gebruik (niet ingemeten)',
    5: 'Pand in gebruik',
    6: 'Verbouwing pand',
    7: 'Sloopvergunning verleend',
    8: 'Pand gesloopt',
    9: 'Pand buiten gebruik',
    10: 'Pand ten onrechte opgevoerd',
}

export const OBJECT_TYPE_MAP = {
    1: 'Verblijfsobject',
    2: 'Standplaats',
    3: 'Ligplaats',
}

export const ALLOWED_MIMES = () =>
    (window && window._appConfig && window._appConfig.ALLOWED_MIMES) || {}

// The upload limits and the profile-status vocabulary live in trustoo_library; these names stay
// so existing `@advanza/constants` imports keep resolving.
export {
    MAX_FILE_SIZE_MB as MAX_FILE_SIZE,
    MAX_POST_SIZE_MB as MAX_POST_SIZE,
} from '@trustoo/constants/fileUpload'

export const PROFILE_STATUS_UNTOUCHED = ProfileStatus.UNTOUCHED
export const PROFILE_STATUS_ENABLED = ProfileStatus.ENABLED
export const PROFILE_STATUS_DISABLED = ProfileStatus.DISABLED
export const PROFILE_STATUS_ON_HOLD = ProfileStatus.ON_HOLD
export const PROFILE_STATUS_GDPR = ProfileStatus.GDPR
export const PROFILE_STATUS_DISABLED_BAD_PROFILE = ProfileStatus.DISABLED_BAD_PROFILE
export const PROFILE_STATUS_GHOST = ProfileStatus.GHOST
export const PROFILE_STATUS_NEW_IMPORT = ProfileStatus.NEW_IMPORT
export const PROFILE_STATUS_CHURNED = ProfileStatus.CHURNED

export const PROFILE_STATUSES_DISABLED: number[] = [...DISABLED_PROFILE_STATUSES]

export const COUNTRY_CODE_LOCALE: Record<string, string> = {
    NL: 'nl',
    BE: 'nl-BE',
    DE: 'de',
    ES: 'es',
}

export const WEBSITE_REGEX =
    /^((https?|ftp|smtp):\/\/)?(www\.)?[-a-z.0-9]+\.[a-z]{2,}(\/[-a-zA-Z0-9#.?&]+\/?)*($|\/)/

export const REASON_DOUBLE_MATCH = 1
export const REASON_NOT_MY_REGION = 2
export const REASON_NOT_MY_SERVICE = 3
export const REASON_NO_CUSTOMER = 5
export const REASON_NO_CONTACT = 7
export const REASON_PHONE_NOT_IN_USE = 8
export const REASON_NOT_SERIOUSLY_LOOKING = 9
export const REASON_NOT_AVAILABLE_ON_DATE = 10

export const RECLAIM_PERIOD_DAYS = 14
export const RECLAIM_EXTENSION_HOURS = 24
export const RECLAIM_COOLDOWN_HOURS = 8
export const RECLAIM_EXPLANATION_MIN_LENGTH = 20

export const CHURN_REASON_COMMENT_MIN_LENGTH = 20
export const CHURN_REASON_COMMENT_MAX_LENGTH = 500

// Back-compat re-export. The enum moved to `@trustoo/enums/UsersActivityTypeSet`.
// Existing imports from `@advanza/constants` keep resolving through here.
export { UsersActivityTypeSet } from '@trustoo/enums/UsersActivityTypeSet'
